import Cookies from 'js-cookie';

import { isLocal } from '@/utils/baseUrl';
import { doGet, doPost } from '@/utils/request';

let APIHost = '/lcsc-op';
if (isLocal) {
  APIHost = 'https://devop.szlcsc.com';
}

const OpApi = {
  websiteSection: `${APIHost}/website/section/list`,
};

export default OpApi;

// client请求接口
let domain = 'lcscOpUrl';
if (isLocal) {
  domain = 'https://devop.szlcsc.com';
}

export function getWebsiteSectionList() {
  return doGet(domain, '/website/section/list');
}

export function overseaSloganList() {
  return doGet(domain, '/oversea/slogan/list');
}

export function advertisingRightSide() {
  return doGet(domain, '/advertising/right/side');
}

export function abtestPing() {
  const fingerId = Cookies.get('_lcsc_fid');
  return doGet(domain, '/abtest/ping', { fingerId });
}

export function getBomPopoverAd() {
  return doGet(domain, '/advertising/bom/upload/popup');
}

export function researchPopupVisible(params) {
  return doGet(domain, '/is/research/popup', params);
}

export function researchPopupClose(params) {
  return doGet(domain, '/async/research/popup/close', params);
}

export function researchPopupSave(data) {
  return doPost(domain, '/async/research/popup/save', data);
}
